

import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  name: "Mq5Aq52SWPdf"
})
export default class Mq5Aq52SWPdf extends Vue {}
